import { ASSETS } from "@/lib/site";
import Reveal from "./Reveal";

export default function PartnerBand() {
  return (
    <section
      data-testid="partner-band"
      className="relative border-y border-white/10 bg-[#050505] py-16 lg:py-20"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex flex-col lg:flex-row items-center justify-between gap-10">
        <Reveal>
          <div className="flex flex-col items-center lg:items-start gap-4">
            <img
              src={ASSETS.logoStacked}
              alt="Leak SmartShield by Caroma"
              data-testid="partner-brand-logo"
              className="h-24 lg:h-28 w-auto object-contain [filter:brightness(0)_invert(1)]"
            />
          </div>
        </Reveal>

        <Reveal delay={0.08}>
          <p className="max-w-xl text-center lg:text-right text-white/55 leading-relaxed">
            The Leak SmartShield valve is genuine{" "}
            <span className="text-white">GWA Water Solutions</span> smart-water technology — one of
            Australia&apos;s most trusted names in water products. Supplied &amp;
            installed by <span className="text-white">The Plumbing &amp; Electrical Co</span>,
            a proud <span className="text-[#169ED9]">Caroma trained Installer</span>.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
